import { useState } from "react";
import { Sparkles, Loader2, Wand2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const AIListingHelper = ({ listingType, details, onGenerated }) => {
  const [loading, setLoading] = useState(false);

  const generate = async () => {
    if (!details || Object.values(details).every(v => !v)) return;
    setLoading(true);
    try {
      const res = await axios.post(`${API}/ai/generate-listing`, { listing_type: listingType, details });
      onGenerated(res.data.description);
    } catch {
      onGenerated("Could not generate description. Please write manually.");
    }
    setLoading(false);
  };

  return (
    <Button type="button" variant="outline" size="sm" onClick={generate} disabled={loading} className="rounded-full text-xs border-marigold/30 text-marigold hover:bg-marigold/5 h-7 px-3" data-testid="ai-generate-button">
      {loading ? <Loader2 size={12} className="animate-spin mr-1" /> : <Wand2 size={12} className="mr-1" />}
      AI Write
    </Button>
  );
};

export default AIListingHelper;
